export const ReactivityValidator = {

	validateDataObject(context, val, depth, variablePath) {
		if (val === undefined) {
			return;
		}
		//każdy element stringa to string,przez to łatwo wpaść w nieskończoną pętle
		//pewnie da się to jakoś obejść, ale nie chce mi się nad tym za długo myślęć
		//taka głębokość "powinna starczyć"
		if (depth === 10) {
			return;
		}

		for (let key in val) {

			let nextPath = variablePath + (Array.isArray(val) ? ("[" + key + "]") : ("." + key));
			if (typeof val !== "string"
				&& !Array.isArray(val)
				&& !this.validatePropertyGetters(val, key)) {
				this.addReactivityError(context, nextPath);
			} else {
				this.validateDataObject(context, val[key], depth + 1, nextPath);
			}

		}
	},

	addReactivityError(context, path) {
		context.reactivityErrors[path] = true;
	},

	validatePropertyGetters(val, key) {
		let descriptor = Object.getOwnPropertyDescriptor(val, key);
		for (let key in descriptor) {
			if (key === "get") {
				return true;
			}
		}
		return false;
	},

	//zmienne computed nie mają reaktywnych getterów, bo i po co
	isComputed(context, key) {
		return Object.keys(context._computedWatchers).find(x => x === key) !== undefined;
	},

	isProp(context, key) {
		return context._props !== undefined && context._props.hasOwnProperty(key);
	},

	validate(context) {

		if (context.reactivityErrors === undefined) {
			context.reactivityErrors = [];
		}

		for (let key in context) {

			if (typeof (context[key]) === "function") {
				continue;
			}

			if (this.isComputed(context, key)) {
				continue;
			}

			//zmienne vue
			if (key[0] === "$" || key[0] === "_") {
				continue;
			}

			//z naszych pluginów/utils
			if (key === "roles" || key === "vErrors" || key === "inputs ") {
				continue;
			}

			//zmienne które dodaje Api
			if (key === "errorResponse" || key === "submitSuccess") {
				continue;
			}

			//zmienna w której trzymamy błędy, które dany obiekt już zgłosił, nie ma sensu dwukrotnie zgłaszać tego samego
			if (key === "reactivityErrors") {
				continue;
			}

			if (!this.validatePropertyGetters(context, key) && !this.isProp(context, key)) {
				this.addReactivityError(context, key);
			} else {
				this.validateDataObject(context, context[key], 0, key);
			}
		}

	},

};
